import styles from './ExamCard.module.css'
import LockGreen from '../../../../assets/LockGreenMweb.svg'
import { useEffect, useState } from 'react'
import PaperCard from '../PaperCard'

const ExamCard = ({ data, profileData, token }) => {
    const DateMonthYear = (dateString) => {
        const date = new Date(dateString)
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: '2-digit',
        })
    }

    const InfoCard = ({ examDate, startTime }) => {
        const [timeLeft, setTimeLeft] = useState(null)
        const [formattedStartTime, setFormattedStartTime] = useState('')

        useEffect(() => {
            if (!examDate || !startTime) {
                setTimeLeft('Invalid Date')
                setFormattedStartTime('Invalid Time')
                return
            }

            const examDateTime = new Date(`${examDate}T${startTime}`)
            if (isNaN(examDateTime.getTime())) {
                setTimeLeft('Invalid Date')
                setFormattedStartTime('Invalid Time')
                return
            }

            let hours = examDateTime.getHours()
            let minutes = examDateTime.getMinutes()
            const period = hours >= 12 ? 'PM' : 'AM'
            hours = hours % 12 || 12 // Convert 0 -> 12 AM
            const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
                .toString()
                .padStart(2, '0')} ${period}`
            setFormattedStartTime(formattedTime)

            const endTime = new Date(examDateTime.getTime() + data.exam_window * 60 * 60 * 1000)

            const updateTimeLeft = () => {
                const diff = endTime - new Date()

                if (diff <= 0) {
                    setTimeLeft('00:00:00')
                    window.location.reload()
                    return
                }

                const hours = Math.floor(diff / (1000 * 60 * 60))
                const minutes = Math.floor((diff / (1000 * 60)) % 60)
                const seconds = Math.floor((diff / 1000) % 60)

                setTimeLeft(
                    `${hours.toString().padStart(2, '0')}:${minutes
                        .toString()
                        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
                )
            }

            const intervalId = setInterval(updateTimeLeft, 1000)
            return () => clearInterval(intervalId)
        }, [examDate, startTime])
        useEffect(() => {
            if (timeLeft === '00:00:00') {
                window.location.reload()
            }
        }, [timeLeft])
        return (
            <div className={styles.infoCard}>
                <div className={styles.infoItem}>
                    Exam Date
                    <span className={styles.infoItemInfo}>
                        {DateMonthYear(examDate)}
                    </span>
                </div>
                <hr />
                <div className={styles.infoItem}>
                    Start Time
                    <span className={styles.infoItemInfo}>{formattedStartTime}</span>
                </div>
                <hr />
                <div className={styles.infoItem}>
                    Closes In
                    <span className={styles.timer}>{timeLeft}</span>
                </div>
                <hr className={styles.lastHr} />
                <div className={styles.status}>
                    Status
                    <span>Ongoing</span>
                </div>
            </div>
        )
    }
    const isDisabled = (paper) => {
        const firstViewResultIndex = data.papers.findIndex(
            (p) => p.btn_txt === 'Begin Test',
        )

        return (
            firstViewResultIndex !== -1 &&
            data.papers.indexOf(paper) > firstViewResultIndex
        )
    }

    const isFinished = data.papers.some((paper) => paper.btn_txt === 'View Result')
    return (
        <div className={styles.cardContainer}>
            <section className={styles.leftContainer}>
                <p style={{ textAlign: 'center', padding: '1rem' }}>{data.series_name}</p>
                <img src={LockGreen} width={133} height={106} alt="Lock" />
            </section>
            <section className={styles.rightContainer}>
                <div className={styles.topSection}>
                    <div className={styles.examInfo}>
                        <p>{data.series_name}</p>
                        <span>{data.status}</span>
                    </div>
                    <InfoCard
                        examDate={data.exam_date}
                        startTime={data.papers[0].start_time}
                        status={data.status}
                    />
                </div>
                {isFinished && (
                    <p className={styles.isFinishedExam}>
                        The detailed result will be available tomorrow
                    </p>
                )}
                <div className={styles.bottomSection}>
                    {data.papers.map((index, key) => (
                        <PaperCard
                            key={key}
                            heading={index.name}
                            buttonLabel={index.btn_txt}
                            buttonVariant={index.btn_txt}
                            profileData={profileData}
                            examData={index}
                            examDate={data.exam_date}
                            test_name={data.series_name}
                            token={token}
                            isDisabled={isDisabled(index)}
                        />
                    ))}
                </div>
            </section>
        </div>
    )
}

export default ExamCard
